import { faPenCircle } from "@fortawesome/pro-regular-svg-icons";
import * as React from "react";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconEdit: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faPenCircle} />;
};
